export const TAG_HEIGHT = 26;
//# sourceMappingURL=tag-column-util.js.map